import * as React from 'react';

import Icon from 'components/Icon';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import TooltipTrigger from 'components/TooltipTrigger';
import Tooltip from 'components/Tooltip';

import './BankCard.scss';

type BankCardBrand = 'american-express' | 'discover' | 'mastercard' | 'visa' | 'other';

type Props = {
  brand?: BankCardBrand;
  expiryMonth: number;
  expiryYear: number;
  lastFour: string;
  zip: string;
};

export default function BankCard({ brand, expiryMonth, expiryYear, lastFour, zip }: Props) {
  const LOGOS = {
    'american-express': require('./images/american-express.svg'),
    discover: require('./images/discover.svg'),
    mastercard: require('./images/mastercard.svg'),
    visa: require('./images/visa.svg'),
    other: require('./images/other.svg'),
  };
  const image = brand ? LOGOS[brand] : LOGOS.other;

  return (
    <div className="BankCard">
      <MediaObject center figure="right">
        <MediaObject center gutter="medium">
          <Image src={image} aria-hidden="true" className="BankCard-logo" />
          <Text size="medium" className="BankCard-numbers">
            <span>•••• •••• •••• {lastFour}</span>
            <span>
              {expiryMonth}/{expiryYear.toString().slice(-2)}
            </span>
            <span>{zip}</span>
          </Text>
        </MediaObject>
        <TooltipTrigger
          placement="top"
          tooltip={<Tooltip>All data is encrypted and protected with bank-level security</Tooltip>}>
          <Icon name="lock-stroked" aria-hidden="true" />
        </TooltipTrigger>
      </MediaObject>
    </div>
  );
}
